module.exports = __webpack_public_path__ + "img/tsp.32bb0f49.svg";